function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["agencyId", "agencyAddressId", "onSubmit", "country"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import { z } from 'zod';
import { Button, Combobox, Dialog, FileUpload, Flex, Spinner, Text, TextInput, createForm, useToasts } from '@applyboard/crystal-ui';
import { ArrowRightOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker, useFeatureDecision, useQueryClient } from '@applyboard/ui-utils';
import { errorMessages, lengthLessThanX, textContainsSymbol } from "../../SignUp/RegisterAsRP/utils";
import { useCountries } from "../../../data/countries";
import { formatBusinessDetailsForApi, usePatchProfile } from "../../../data/profile";
import { useUser } from "../../../data/user/useUser";
import { FeatureFlagKey } from "../../../utils/localFeatureDecision";
import { AddressSearch } from "../AddressSearch";
import { ProfileStepper } from "../ProfileStepper";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var DEFAULT_FORM_VALUES = {
  firstName: '',
  lastName: '',
  businessName: '',
  businessRegistrationCertificate: [],
  country: '',
  streetAddress: '',
  city: '',
  state: '',
  zip: ''
};
var MIN_INPUT_LENGTH = 5;
var MAX_INPUT_LENGTH = 120;
var MAX_FILE_SIZE = 5000000; // 5MB
var ALLOWED_FILE_TYPES = ['.jpeg', '.jpg', '.png', '.pdf'];
var _createForm = createForm(),
  Form = _createForm.Form,
  Field = _createForm.Field,
  useSetFieldValues = _createForm.useSetFieldValues;
var validateMaxCharLength = function validateMaxCharLength(text) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_INPUT_LENGTH;
  var parseResult = z.string().max(MAX_INPUT_LENGTH, "This must be at most ".concat(maxLength, " characters.")).safeParse(text);
  if (!parseResult.success) return parseResult.error.issues[0].message;
  return true;
};
var validateStreetAddress = function validateStreetAddress(text) {
  var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MIN_INPUT_LENGTH;
  var maxLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_INPUT_LENGTH;
  var parseResult = z.string().max(MAX_INPUT_LENGTH, "This must be at most ".concat(maxLength, " characters.")).min(MIN_INPUT_LENGTH, "This must be at least ".concat(minLength, " characters.")).regex(/^[^&<>@~%^*$\\{}|=]+$/, 'This contains invalid characters.').safeParse(text);
  if (!parseResult.success) return parseResult.error.issues[0].message;
  return true;
};
var firstNameLastNameValidation = function firstNameLastNameValidation(text) {
  if (text.trim().length === 0) return errorMessages.required;
  if (!lengthLessThanX(text.trim(), 100)) return errorMessages.maxLength(100);
  if (textContainsSymbol(text.trim())) return errorMessages.shouldNotIncludeSpecialChar;
  return true;
};
export function BusinessDetails(_ref) {
  var _countries$filter$map;
  var agencyId = _ref.agencyId,
    agencyAddressId = _ref.agencyAddressId,
    _onSubmit = _ref.onSubmit,
    countryId = _ref.country,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useCountries = useCountries(),
    countries = _useCountries.countries;
  var _usePatchProfile = usePatchProfile(),
    patchProfile = _usePatchProfile.patchProfile,
    patchProfileIsLoading = _usePatchProfile.patchProfileIsLoading;
  var _useUser = useUser(),
    user = _useUser.user,
    isLoadingUser = _useUser.isLoadingUser;
  var toasts = useToasts();
  var queryClient = useQueryClient();
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var country = (_countries$filter$map = countries.filter(function (country) {
    return country.id === countryId;
  }).map(function (_ref2) {
    var id = _ref2.id,
      code = _ref2.code;
    return "".concat(id, "|").concat(code);
  }).at(0)) !== null && _countries$filter$map !== void 0 ? _countries$filter$map : '';
  var _useFeatureDecision = useFeatureDecision(),
    _useFeatureDecision2 = _slicedToArray(_useFeatureDecision, 2),
    decisionEngine = _useFeatureDecision2[0],
    decisionEngineReady = _useFeatureDecision2[1];
  var isAbidCustomizationLogin = decisionEngineReady ? decisionEngine.isFeatureEnabled(FeatureFlagKey.UseAbidCustomizationLogin) : false;
  React.useEffect(function () {
    trackEvent({
      group: 'Profile Creation',
      event: 'Create Profile - Business Details Loaded'
    });
  }, [trackEvent]);
  if (isLoadingUser) {
    return _jsxs(Dialog, {
      open: true,
      size: "md",
      onOpenChange: function onOpenChange() {},
      children: [_jsx(Dialog.Heading, {
        children: "Create profile"
      }), _jsx(Dialog.Content, {
        children: _jsx(Flex, {
          justify: "center",
          align: "center",
          height: "hug",
          children: _jsx(Spinner, {
            size: "lg"
          })
        })
      })]
    });
  }
  return _jsxs(Dialog, {
    open: true,
    size: "md",
    onOpenChange: function onOpenChange() {},
    children: [_jsx(Dialog.Heading, {
      children: "Create profile"
    }), _jsxs(Dialog.Content, {
      children: [_jsx(ProfileStepper, {
        step: 0
      }), _jsxs(Flex, {
        direction: "column",
        gap: 8,
        children: [_jsx(Text, {
          as: "div",
          intent: "secondary",
          variant: "bodyM",
          children: "Let's get to know you better. Add your official business name, address, and registration documents."
        }), _jsx(Form, {
          defaultValues: _objectSpread(_objectSpread({}, DEFAULT_FORM_VALUES), {}, {
            country: country,
            firstName: user === null || user === void 0 ? void 0 : user.firstName,
            lastName: user === null || user === void 0 ? void 0 : user.lastName
          }, rest),
          onSubmit: function onSubmit(values) {
            if (patchProfileIsLoading) return;
            var hasChangedCertificate = values.businessRegistrationCertificate.length > 0 && values.businessRegistrationCertificate[0].file.size !== 0; // Dummy files have size 0

            var formattedData = formatBusinessDetailsForApi({
              businessDetails: values,
              agencyAddressId: agencyAddressId,
              isAbidCustomizationLogin: isAbidCustomizationLogin,
              hasChangedCertificate: hasChangedCertificate
            });
            patchProfile({
              agencyId: agencyId,
              formattedData: formattedData,
              isAbidCustomizationLogin: isAbidCustomizationLogin,
              endpointType: 'business_details'
            }, {
              onSuccess: function onSuccess(data) {
                queryClient.setQueryData(['profile', {
                  agencyId: agencyId
                }], data);
                trackEvent({
                  group: 'Profile Creation',
                  event: 'Create Profile - Business Details - Clicked Next',
                  data: {
                    success: true
                  }
                });
                _onSubmit();
              },
              onError: function onError(error) {
                toasts.negative(new Error('Could not save the data. Please try again later.'));
                trackEvent({
                  group: 'Profile Creation',
                  event: 'Create Profile - Business Details - Clicked Next',
                  data: {
                    success: false
                  },
                  error: error
                });
              }
            });
          },
          id: "rp-create-profile-business-details",
          children: _jsxs(Flex, {
            direction: "column",
            gap: 6,
            children: [isAbidCustomizationLogin && _jsxs(Flex, {
              "flex-grow": 1,
              "flex-basis": 1,
              direction: {
                sm: 'row',
                xs: 'column'
              },
              gap: 4,
              children: [_jsx(Flex.Item, {
                basis: "50%",
                children: _jsx(Field, {
                  name: "firstName",
                  label: "1. First name",
                  as: TextInput,
                  required: "This is required.",
                  validate: firstNameLastNameValidation
                })
              }), _jsx(Flex.Item, {
                basis: "50%",
                children: _jsx(Field, {
                  name: "lastName",
                  label: "2. Last name",
                  as: TextInput,
                  required: "This is required.",
                  validate: firstNameLastNameValidation
                })
              })]
            }), _jsx(Field, {
              name: "businessName",
              label: "3. Registered business name",
              as: TextInput,
              required: "This is required.",
              validate: function validate(businessName) {
                var parseResult = z.string().max(MAX_INPUT_LENGTH, "This must be at most ".concat(MAX_INPUT_LENGTH, " characters")).regex(/^[A-Za-z0-9\s\-.&']+$/, 'Please enter the official business name in English (Latin alphabet), as per your registration documents').safeParse(businessName);
                if (!parseResult.success) return parseResult.error.issues[0].message;
                return true;
              },
              helpText: "This name must match your official business registration documents (e.g. business certificate)."
            }), _jsx(Field, {
              allowedFileTypes: ALLOWED_FILE_TYPES,
              maxFileSize: MAX_FILE_SIZE,
              name: "businessRegistrationCertificate",
              label: "4. Business registration certificate",
              as: FileUpload,
              size: "sm",
              required: "This is required. Please upload a business registration certificate.",
              helpText: "The name on this document must match your official business name. Please make sure the file is in PDF, PNG or JPEG file format and is not larger than 5MB in size."
            }), _jsx(AddressFieldset, {
              countries: countries
            })]
          })
        })]
      })]
    }), _jsx(Dialog.Actions, {
      children: _jsx(Button, {
        form: "rp-create-profile-business-details",
        intent: "primary",
        type: "submit",
        width: "fill",
        loading: patchProfileIsLoading,
        trailIcon: ArrowRightOutlineIcon,
        children: "Continue"
      })
    })]
  });
}
function AddressFieldset(_ref3) {
  var countries = _ref3.countries;
  var setFieldValues = useSetFieldValues();
  return _jsxs(Flex, {
    direction: "column",
    gap: 6,
    children: [_jsx(Text, {
      children: "Enter your business address below."
    }), _jsx(AddressSearch, {
      countries: countries,
      onChange: function onChange(address) {
        return setFieldValues(address);
      }
    }), _jsx(Field, {
      name: "country",
      label: "Country/Region",
      as: Combobox,
      required: "This is required.",
      helpText: "Select a country from the list.",
      children: countries.map(function (countryName) {
        return _jsx(Combobox.Option, {
          label: countryName.name,
          value: "".concat(countryName.id, "|").concat(countryName.code)
        }, countryName.id);
      })
    }), _jsx(Field, {
      name: "streetAddress",
      label: "Street address",
      as: TextInput,
      required: "This is required.",
      helpText: "Include the street name and number, if applicable.",
      validate: function validate(streetAddress) {
        return validateStreetAddress(streetAddress);
      }
    }), _jsx(Field, {
      validate: function validate(city) {
        return validateMaxCharLength(city);
      },
      name: "city",
      label: "City/Town",
      as: TextInput,
      required: "This is required."
    }), _jsx(Field, {
      name: "state",
      label: "State/Province",
      as: TextInput,
      required: "This is required.",
      helpText: "Select state or province, if applicable.",
      validate: function validate(state) {
        return validateMaxCharLength(state);
      }
    }), _jsx(Field, {
      name: "zip",
      label: "ZIP/Postal code",
      as: TextInput,
      helpText: "Add your ZIP or postal code, if applicable."
    })]
  });
}